/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkout_No_Withdrawal_PrefixInputs */

const en_checkout_no_withdrawal_prefix = /** @type {(inputs: Checkout_No_Withdrawal_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accommodation booked for specific dates is not covered by the standard 14-day right of withdrawal; our`)
};

/**
* | output |
* | --- |
* | "Accommodation booked for specific dates is not covered by the standard 14-day right of withdrawal; our" |
*
* @param {Checkout_No_Withdrawal_PrefixInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const checkout_no_withdrawal_prefix = /** @type {((inputs?: Checkout_No_Withdrawal_PrefixInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkout_No_Withdrawal_PrefixInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_checkout_no_withdrawal_prefix(inputs)
});